<script>
  export let margin;
  document.body.style.setProperty("--margin", margin);

  import { debug } from "../store.js";
</script>

<div class="locked-margin-container" class:debug={$debug} />

<style type="text/scss">
  .locked-margin-container {
    height: var(--margin);

    &.debug {
      background: rgba(0, 0, 0, 0.1);
    }
  }
</style>
